import React, { Fragment } from 'react';
import { func, string } from 'prop-types';
import formatDates from './date-utils/format-dates';

/**
 * @private
 * @memberof nr-omni-shipping-pickup
 * @description Renders appropriate arrival date messaging with local specific date formatting.  If given minShipDate, render date range
 *
 * @param {object} props - react component props
 * @param {Function} props.arrivesMessage - message show if given postal code
 * @param {Function} props.arrivesByMessage - message shown if minimum arrival date and maximum date
 * @param {string} props.minShipDate - earliest arrival date
 * @param {string} props.maxShipDate - latest arrival date
 * @param {string} props.timeZone - timezone of latest arrival date
 * @param {string} props.language - language sensitive date and time formatting
 * @returns {React.Component} - react component
 */
export default function ArrivesDate(_ref) {
  var arrivesMessage = _ref.arrivesMessage,
    arrivesByMessage = _ref.arrivesByMessage,
    minShipDate = _ref.minShipDate,
    maxShipDate = _ref.maxShipDate,
    timeZone = _ref.timeZone,
    language = _ref.language;
  var _formatDates = formatDates({
      timeZone: timeZone,
      minDate: minShipDate,
      maxDate: maxShipDate,
      language: language
    }),
    formattedMinDate = _formatDates.formattedMinDate,
    formattedMaxDate = _formatDates.formattedMaxDate;
  if (minShipDate && formattedMinDate !== formattedMaxDate) {
    return /*#__PURE__*/React.createElement(Fragment, null, arrivesMessage(), "\xA0", formattedMinDate, " - ", formattedMaxDate);
  }
  return /*#__PURE__*/React.createElement(Fragment, null, arrivesByMessage(), "\xA0", formattedMaxDate);
}
ArrivesDate.propTypes = {
  arrivesMessage: func,
  arrivesByMessage: func,
  minShipDate: string,
  maxShipDate: string,
  timeZone: string,
  language: string
};